import React, { FunctionComponent } from 'react';
import { PlayerDiv } from '../component/player/PlayerDiv';

interface Props {
  selectThemeFromMain: number;
  onChange: (e: any) => void;
}

export const PlayerPage: FunctionComponent<Props> = ({
  selectThemeFromMain,
  onChange,
}) => (
  <PlayerDiv selectThemeFromMain={selectThemeFromMain} onChange={onChange} />
);
